<template>
    <draggable v-show="expanded || model.level==0" v-model="model.children" :options="options" @start="onStart"
               @end="onEnd">
        <li @dragover="hover" v-for="element in model.children" :key="element.name" :id="element.name" class="drag-elem"
            :class="{ 'drag-elem-active':hoverIdNotProp=== element.name && hoverIdNotProp!== draggedId,'last':hasChildren }">
            <v-icon :id="element.name"
                    v-show="element.children.length>0 && !getExpanded(element.name) && iconsVisibility"
                    @click="expand(element.name)">add

            </v-icon>
            <v-icon :id="element.name"
                    v-show="element.children.length>0 && getExpanded(element.name) && iconsVisibility"
                    @click="expand(element.name)">remove

            </v-icon>
            <v-edit-dialog lazy :id="element.name" @open="changeName = element.name" @close="updateName(element.name)">
                {{ element.name }}


                <v-text-field slot="input" label="Edit" single-line v-model="changeName"></v-text-field>
            </v-edit-dialog>
            <v-icon :id="element.name" v-show="iconsVisibility && model.level!==0" @click="up(element)">arrow_upward
            </v-icon>
            <span :id="element.name"
                  class="sum-hours-label"> {{ resursiveHoursSum(element.children, element.hours).toFixed(2)}} h </span>
            <ul :class="{'tree':model.name==='firstPart'||model.name==='secondPart'}" v-show="hasChildren ">
                <DragableTree @up='pasteUp' @clear="onClear" @drop="drop" :hoverId="hoverIdNotProp" :model="element"
                              :ref="element.name">
                </DragableTree>
            </ul>
        </li>
    </draggable>
</template>

<script>
    import draggable from 'vuedraggable';
    import _ from 'lodash';
    export default {
        name: 'DragableTree',
        props: {
            model: Object,
            hoverId: String,
            sortByHours: Boolean,
            sortByName: Boolean
        },
        components: {
            draggable
        },
        computed: {
            hasChildrens: function () {
                return this.model.children &&
                    this.model.children.length
            }
        },
        created(){
            this.sort();
        },
        data() {
            return {
                options: {
                    ghostClass: 'ghost',
                    sort: false
                },
                drag: false,
                draggedId: false,
                hoverIdNotProp: '',
                changeName: '',
                expanded: false,
                iconsVisibility: true,
                byHours: false,
                byName: true
            }
        },
        watch: {
            hoverId: function (newValue) {
                this.hoverIdNotProp = newValue
            },
            sortByHours: function (newValue) {
                this.byName = false;
                this.byHours = true;
                this.recursiveSortByHours(this.model);
            },
            sortByName: function (newValue) {
                this.byName = true;
                this.byHours = false;
                this.recursiveSortByName(this.model);
            }
        },
        methods: {
            drop(hoverId, newElem, prev) {
                return this.paste(hoverId, newElem, prev);
            },
            hover(e) {
                this.hoverIdNotProp = e.target.id;
            },
            onStart(e) {
                this.drag = true
                this.draggedId = e.item.id;
            },
            hasChildren(element) {
                return element.children.length > 0 ? true : false
            },
            onEnd(e) {
                this.drag = false
                let targetIndex = _.findIndex(this.model.children, elem => elem.name === this.hoverIdNotProp);
                let draggedIndex = _.findIndex(this.model.children, elem => elem.name === this.draggedId);
                if (targetIndex !== -1 && draggedIndex !== -1 && targetIndex !== draggedIndex) {
                    let newElem = _.clone(this.model.children[draggedIndex]);
                    newElem.level++;
                    this.model.children[targetIndex].children.push(newElem);
                    _.remove(this.model.children, elem => elem.name === this.draggedId);
                    this.clear();
                    this.$emit('clear');
                } else {
                    if (draggedIndex !== -1) {
                        let newElem = _.clone(this.model.children[draggedIndex]);
                        this.$emit('drop', this.hoverIdNotProp, newElem, this.model.name);
                    }
                }
                this.draggedId = false;
                this.hoverIdNotProp = '';
            },
            paste(hoverId, dragged, prev) {
                if (hoverId !== dragged.name) {
                    if (this.model.name == hoverId && _.findIndex(this.model.children, child => child.name === dragged.name) == -1) {
                        this.model.children.push(dragged);
                        this.$refs[prev][0].remove(dragged);
                        this.clear();
                        this.$emit('clear');
                    } else {
                        if (_.findIndex(this.model.children, child => child.name === dragged.name) !== -1) {
                            this.clear();
                            this.$emit('clear');
                        } else {
                            let targetIndex = _.findIndex(this.model.children, child => child.name === hoverId);
                            if (targetIndex !== -1 && _.findIndex(this.model.children[targetIndex].children, child => child.name === dragged.name) == -1) {
                                this.model.children[targetIndex].children.push(dragged)
                                this.$refs[prev][0].remove(dragged);
                                this.clear();
                                this.$emit('clear');
                            } else {
                                if (targetIndex !== -1 && _.findIndex(this.model.children[targetIndex].children, child => child.name === dragged.name) !== -1) {
                                    this.clear();
                                    this.$emit('clear');
                                } else {
                                    this.prev = prev;
                                    this.$emit('drop', hoverId, dragged, this.model.name);
                                }
                            }
                        }
                    }
                } else {
                    this.clear();
                    this.$emit('clear');
                }
            },
            remove(dragged) {
                let draggedIndex = _.findIndex(this.model.children, elem => elem.name === dragged.name);
                if (draggedIndex !== -1) {
                    _.remove(this.model.children, elem => elem.name === dragged.name);

                } else {
                    this.$refs[this.prev][0].remove(dragged);
                }
            },
            onClear() {
                this.draggedId = false;
                this.hoverIdNotProp = '';
                this.$emit('clear');
                this.clear();

            },
            clear() {
                this.draggedId = false;
                this.hoverIdNotProp = '';
                _.forIn(this.$refs, (value, key) => {
                    _.forEach(this.$refs[key], ref => {
                        ref.clear();
                    })
                })
                this.sort();
            },
            resursiveHoursSum(array, sum) {
                return array.length > 0 ? _.sumBy(array, elem => this.resursiveHoursSum(elem.children, elem.hours)) + sum : sum;
            },
            updateName(name) {
                let index = _.findIndex(this.model.children, child => child.name === name);
                if (index !== -1) {
                    this.model.children[index].name = this.changeName;
                }
            },
            expand(name) {
                this.$refs[name][0].expandChilds()
            },
            expandChilds(el) {
                this.expanded = el !== undefined ? el : !this.expanded;
            },
            getExpanded(name) {
                if (this.$refs[name]) {
                    return this.$refs[name][0] && this.$refs[name][0].expanded;
                }
            },
            onHideIcons() {
                this.iconsVisibility = !this.iconsVisibility
            },
            hideIcons() {
                this.iconsVisibility = !this.iconsVisibility
                _.forIn(this.$refs, (value, key) => {
                    _.forEach(this.$refs[key], ref => {
                        ref.onHideIcons();
                    })
                })
            },
            up(dragged) {
                this.expanded = false;
                this.$emit('up', dragged, this.model.name)
            },
            pasteUp(dragged, prev) {
                this.model.children.push(dragged);
                this.$refs[prev][0].remove(dragged);
                this.clear();
                this.$emit('clear');
            },
            recursiveSortByName(model) {
                model.children = _.sortBy(model.children, 'name');
                return model.children.length > 0 ? _.map(model.children, element => this.recursiveSortByName(element)) : model;
            },
            recursiveSortByHours(model) {
                model.children = _.sortBy(model.children, element => this.resursiveHoursSum(element.children, element.hours));
                return model.children.length > 0 ? _.map(model.children, element => this.recursiveSortByHours(element)) : model;
            },
            sort() {
                switch (true) {
                    case this.byHours:
                        return this.recursiveSortByHours(this.model);
                        break;
                    case this.byName:
                        return this.recursiveSortByName(this.model);
                        break;
                    default:
                        return this.recursiveSortByName(this.model);
                        break;
                }
            }
        }
    }
</script>

<style>
    .menu__activator a {
        font-size: 16px;
    }

    .description {
        display: block;
    }

    .own-hours-label {
        display: block;
        font-size: 12px;
    }

    .sum-hours-label {
        display: block;
        font-size: 15px;
    }

    .ghost {
        opacity: .5;
        background: #e2e2e2;
    }

    .drag-elem-active {
        background-color: #666666;
    }

    li {
        cursor: pointer;
    }

    .hours {
        display: block;
    }

    .hours-sum {
        display: block;
    }

    /* try to add tree */
    .clt,
    .clt ul,
    .clt li {
        position: relative;
        text-align: left;
        font-size: 20px;
        list-style: none;
        margin-left: 10px;
        padding: 3px;
        padding-left: 14px;
    }

    .clt ul {
        list-style: none;
        padding-left: 40px;
        text-align: left;
    }

    .clt li::before,
    .clt li::after {
        content: "";
        position: absolute;
        left: -12px;
        text-align: left;
    }

    .clt li::before {
        border-top: 1px solid #000;
        top: 17px;
        width: 14px;
        height: 0;
        text-align: left;
    }

    .clt li::after {
        border-left: 1px solid #000;
        height: 100%;
        width: 0px;
        top: 2px;
        text-align: left;
    }

    .clt ul > li:last-child::after {
        height: 8px;
        text-align: left;
    }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Components/DragableTree.vue